// Modül 3 - Aday Nasıl Davranmalı? - Ek İçerikler

const cabinCrewContentsM3Extra = {
  // Ünite 3 - İletişim Stratejileri
  'CM-M3-U3-L1': {
    title: 'Sözsüz İletişim',
    type: 'lesson',
    content: {
      introduction: 'Beden diliniz sözlerinizden daha çok şey anlatır. Mülakatta doğru mesajları verin.',
      sections: [
        {
          title: 'Duruş ve Postür',
          content: 'Dik oturun, omuzlarınızı geri çekin, ayaklarınızı yere basın. Çapraz kol bağlamaktan kaçının. Açık ve rahat bir duruş sergileyin.'
        },
        {
          title: 'Göz Teması',
          content: 'Konuşurken ve dinlerken göz teması kurun. Ama sürekli dikkatli bakmak yerine, doğal bir şekilde bakışlarınızı dağıtın.'
        },
        {
          title: 'El Hareketleri',
          content: 'Ellerinizi saklamamak, açık tutmak güven verir. Aşırı el hareketi yapmayın ama tamamen hareketsiz de kalmayın.'
        },
        {
          title: 'Yüz İfadesi',
          content: 'Doğal gülümseme en güçlü silahınızdır. Zoraki gülümseme kolayca anlaşılır. Olumlu ve ilgili görünün.'
        }
      ],
      tips: ['Ayna karşısında pratik yapın', 'Video kaydı alıp izleyin', 'Rahat olun - gerginlik beden diline yansır']
    }
  },
  'CM-M3-U3-L2': {
    title: 'Etkili Konuşma Teknikleri',
    type: 'lesson',
    content: {
      introduction: 'Ne söylediğiniz kadar nasıl söylediğiniz de önemlidir.',
      sections: [
        {
          title: 'Ses Tonu ve Hızı',
          content: 'Monoton konuşmayın, vurgu yapın. Çok hızlı veya çok yavaş konuşmayın. Doğal bir ritim yakalayın.'
        },
        {
          title: 'Net ve Kısa Cevaplar',
          content: 'Uzun monologlardan kaçının. Soruyu cevaplayın, örnek verin, sonlandırın. STAR metodunu kullanın.'
        },
        {
          title: 'Dolgu Kelimelerden Kaçınma',
          content: '\'Şey\', \'yani\', \'işte\' gibi dolgu kelimeleri azaltın. Duraklamak sorun değil, dolgu kelimesi kullanmaktan iyidir.'
        }
      ],
      tips: ['Kendinizi kaydedin ve dinleyin', 'Pratik pratik pratik', 'Derin nefes alın']
    }
  },
  'CM-M3-U3-L3': {
    title: 'Senaryo: Zor Soru Anı',
    type: 'scenario',
    scenario: {
      title: 'Beklenmedik Soru',
      situation: 'Grup mülakatında panel size beklenmedik bir soru soruyor: \'Bir hayvan olsaydınız ne olurdunuz ve neden?\' Yanınızdaki aday çok yaratıcı bir cevap verdi ve sıra size geldi.',
      question: 'Bu durumu nasıl yönetirsiniz?',
      options: [
        { id: 'a', text: 'Önceki adayın cevabını beğendiğimi söyleyip benzer bir şey söylerim', correct: false },
        { id: 'b', text: 'Düşünmek için zaman isteyip özgün bir cevap oluştururum', correct: true },
        { id: 'c', text: 'Bu tür soruları saçma bulduğumu söylerim', correct: false },
        { id: 'd', text: 'Cevap vermekten kaçınırım', correct: false }
      ],
      explanation: 'Bu tür sorular yaratıcılığınızı ve baskı altında düşünme yeteneğinizi test eder. Özgün olun, cevabınızı kabin memurluğuna bağlayın (örn: \'Arı olurdum çünkü ekip çalışmasına inanırım ve sürekli hareket halinde olmayı severim\').'
    }
  },
  'CM-M3-U3-L4': {
    title: '🎮 İletişim Eşleştirme',
    type: 'matching',
    game: {
      instruction: 'Doğru davranışı doğru etkiyle eşleştirin.',
      pairs: [
        { left: 'Göz teması', right: 'Güven ve samimiyet' },
        { left: 'Dik duruş', right: 'Özgüven' },
        { left: 'Doğal gülümseme', right: 'Sıcaklık' },
        { left: 'Açık el pozisyonu', right: 'Dürüstlük' },
        { left: 'Baş sallamak', right: 'Aktif dinleme' }
      ],
      timeLimit: 45
    }
  },

  // Ünite 4 - Grup İçi Roller
  'CM-M3-U4-L1': {
    title: 'Grup Mülakatında Roller',
    type: 'lesson',
    content: {
      introduction: 'Grup çalışmasında farklı roller ortaya çıkar. Hangi rolü üstlenmelisiniz?',
      sections: [
        {
          title: 'Lider Tipi',
          content: 'Grubu yönlendiren, organize eden kişi. Dikkat: Baskıcı olmak negatif algılanır. Doğal liderlik değerlidir.'
        },
        {
          title: 'Koordinatör',
          content: 'Fikirleri birleştiren, herkesin katılımını sağlayan kişi. Bu rol çok değerlidir.'
        },
        {
          title: 'Fikir Üreticisi',
          content: 'Yaratıcı öneriler sunan kişi. Ancak sadece fikir vermek yetmez, uygulamaya da katkı şart.'
        },
        {
          title: 'Destekçi',
          content: 'Başkalarının fikirlerini geliştiren, grup uyumunu sağlayan kişi. Pasif kalmamak önemli.'
        }
      ],
      tips: ['Tek bir role takılmayın', 'Duruma göre uyum sağlayın', 'Dengeyi koruyun']
    }
  },
  'CM-M3-U4-L2': {
    title: 'Rekabet vs İşbirliği',
    type: 'lesson',
    content: {
      introduction: 'Grup mülakatı bir yarışma değil, ekip çalışması değerlendirmesidir.',
      sections: [
        {
          title: 'Yanlış Anlayış',
          content: 'Birçok aday diğerlerini \'rakip\' görür. Bu, kötü bir stratejidir. Havayolları işbirliği yeteneği arar.'
        },
        {
          title: 'Doğru Yaklaşım',
          content: 'Diğer adayları destekleyin, fikirlerine değer verin. Birlikte başarı, bireysel parlama girişiminden daha etkileyicidir.'
        },
        {
          title: 'Win-Win Mentalitesi',
          content: 'Herkesin kazanabileceği çözümler arayın. \'Benim için değil, grup için\' düşüncesi.'
        }
      ],
      tips: ['Başkalarının sözünü kesmeyin', 'Başkalarının fikirlerini takdir edin', 'Herkesin konuşmasına alan açın']
    }
  },
  'CM-M3-U4-L3': {
    title: 'Senaryo: Baskın Aday',
    type: 'scenario',
    scenario: {
      title: 'Zorlu Grup Dinamiği',
      situation: 'Grup aktivitesinde bir aday sürekli konuşuyor, başkalarının sözünü kesiyor ve kendi fikirlerini dayatıyor. Grup enerjisi düşüyor ve bazı adaylar susmaya başladı.',
      question: 'Bu durumda ne yaparsınız?',
      options: [
        { id: 'a', text: 'O adayla tartışırım ve haddini bildiririm', correct: false },
        { id: 'b', text: 'Sessiz kalan adaylara dönerek \'Sen ne düşünüyorsun?\' diye sorarım', correct: true },
        { id: 'c', text: 'Ben de onun gibi davranırım', correct: false },
        { id: 'd', text: 'Tamamen sessiz kalırım', correct: false }
      ],
      explanation: 'Çatışma yaratmadan grup dinamiğini düzeltmek en değerli beceridir. Sessiz adayları dahil etmek, baskın adaya nazikçe sınır koymak olumlu değerlendirilir.'
    }
  },
  'CM-M3-U4-L4': {
    title: '⚡ Rol Yarışı',
    type: 'timerace',
    game: {
      instruction: '40 saniyede grup rolleri hakkındaki soruları cevaplayın!',
      questions: [
        { question: 'Fikirleri birleştiren rol?', answer: 'Koordinatör', options: ['Lider', 'Koordinatör', 'Muhalif', 'Takipçi'] },
        { question: 'Grup mülakatında en değerli beceri?', answer: 'İşbirliği', options: ['Rekabet', 'Baskınlık', 'İşbirliği', 'Sessizlik'] },
        { question: 'Baskın aday karşısında ne yapmalı?', answer: 'Dengeleyici ol', options: ['Tartış', 'Sus', 'Dengeleyici ol', 'Aynısını yap'] },
        { question: 'Win-win ne demek?', answer: 'Herkes kazansın', options: ['Ben kazanayım', 'Herkes kazansın', 'Kimse kazanmasın', 'Şirket kazansın'] }
      ],
      timeLimit: 40
    }
  },

  // Ünite 5 - Pratik Senaryolar
  'CM-M3-U5-L1': {
    title: 'Sık Yapılan Hatalar',
    type: 'lesson',
    content: {
      introduction: 'Grup mülakatlarında adayların yaptığı yaygın hatalar ve bunlardan kaçınma yolları.',
      sections: [
        {
          title: 'Aşırı Konuşma',
          content: 'Sürekli konuşmak, değerlendirmecilerin dikkatini çekmek için iyi bir strateji değildir. Kaliteli katkı, miktardan önemlidir.'
        },
        {
          title: 'Tamamen Sessiz Kalma',
          content: 'Hiç konuşmamak, değerlendirilememek demektir. En azından birkaç kez kaliteli katkı yapılmalıdır.'
        },
        {
          title: 'Diğer Adayları Eleştirme',
          content: 'Başka adayların fikirlerini kötülemek profesyonellik eksikliği gösterir. Alternatif sunmak daha iyi.'
        },
        {
          title: 'Panel ile Göz Teması Eksikliği',
          content: 'Sadece grup üyelerine değil, panele de ara ara bakış atılmalıdır.'
        }
      ],
      tips: ['Kendinizi dışarıdan izleyin', 'Dengeli olun', 'Doğal davranın']
    }
  },
  'CM-M3-U5-L2': {
    title: 'Senaryo: Fikir Çatışması',
    type: 'scenario',
    scenario: {
      title: 'Zıt Görüşler',
      situation: 'Grup aktivitesinde takım ikiye bölündü. Yarısı A planını, yarısı B planını destekliyor. Tartışma kızışıyor ve panel izliyor.',
      question: 'Grup liderliğini almadan bu durumu nasıl çözersiniz?',
      options: [
        { id: 'a', text: '\'Her iki planda da değerli noktalar var. Bunları birleştirebilir miyiz?\' derim', correct: true },
        { id: 'b', text: 'En güçlü tarafa katılırım', correct: false },
        { id: 'c', text: 'Oylama teklif ederim', correct: false },
        { id: 'd', text: 'Panele sorarım hangisi doğru', correct: false }
      ],
      explanation: 'Uzlaştırıcı olmak ve ortak zemin bulmak, çatışma çözme yeteneğini gösterir. Bu, kabin ortamında çok değerli bir beceridir.'
    }
  },
  'CM-M3-U5-L3': {
    title: '🎮 Hata Bul: Doğru/Yanlış',
    type: 'truefalse',
    game: {
      instruction: 'Grup mülakatı davranışları hakkındaki ifadeleri değerlendirin.',
      statements: [
        { statement: 'En çok konuşan aday en başarılıdır', isTrue: false, explanation: 'Kalite miktardan önemlidir' },
        { statement: 'Sessiz adayları dahil etmek olumlu değerlendirilir', isTrue: true, explanation: 'Kapsayıcılık ve ekip bilinci gösterir' },
        { statement: 'Liderlik her zaman olumludur', isTrue: false, explanation: 'Doğal liderlik olumlu, baskıcı liderlik olumsuz' },
        { statement: 'Panele ara ara göz teması kurulmalı', isTrue: true, explanation: 'Sadece grup üyeleriyle değil, değerlendirmecilerle de bağlantı önemli' },
        { statement: 'Fikirler eleştirilmemeli', isTrue: false, explanation: 'Yapıcı eleştiri kabul edilebilir, ama kişisel saldırı kabul edilmez' }
      ]
    }
  },

  // Ünite 6 - Final Quiz
  'CM-M3-U6-L1': {
    title: '🎓 Modül 3 Final Sınavı',
    type: 'exam',
    exam: {
      title: 'Aday Nasıl Davranmalı? - Final Sınavı',
      passingScore: 70,
      questions: [
        {
          question: 'Sözsüz iletişimde en güçlü unsur hangisidir?',
          options: ['Kıyafet', 'Doğal gülümseme', 'Parfüm', 'Takılar'],
          correct: 1
        },
        {
          question: 'Dolgu kelimelerden kaçınmanın faydası nedir?',
          options: ['Zaman kazanmak', 'Daha profesyonel görünmek', 'Daha az konuşmak', 'Accent gizlemek'],
          correct: 1
        },
        {
          question: 'Koordinatör rolü ne yapar?',
          options: ['Herkesi yönetir', 'Fikirleri birleştirir', 'En çok konuşur', 'Karar verir'],
          correct: 1
        },
        {
          question: 'Grup mülakatında en kötü davranış hangisidir?',
          options: ['Fikirlerine katkıda bulunmak', 'Diğer adayları eleştirmek', 'Sessiz kalmak', 'Soru sormak'],
          correct: 1
        },
        {
          question: 'Baskın adayla nasıl başa çıkılır?',
          options: ['Tartışmak', 'Sessiz adayları dahil etmek', 'Şikayet etmek', 'Aynısını yapmak'],
          correct: 1
        },
        {
          question: 'Win-win yaklaşımı ne anlama gelir?',
          options: ['En iyi olmak', 'Herkesin faydasını gözetmek', 'Yenmek', 'Kaybetmemek'],
          correct: 1
        },
        {
          question: 'Fikir çatışmasında en iyi yaklaşım?',
          options: ['Güçlü tarafa katılmak', 'Uzlaşma aramak', 'Panele sormak', 'Sessiz kalmak'],
          correct: 1
        },
        {
          question: 'Göz teması neden önemlidir?',
          options: ['Kural olduğu için', 'Güven ve samimiyet gösterir', 'Dikkat dağıtmak için', 'Zaman kazanmak için'],
          correct: 1
        }
      ]
    }
  }
};

export default cabinCrewContentsM3Extra;
